/**
 * Shared font utilities.
 */

export function getSafeFamilyName(
  font?: {
    family?: string | null;
    name?: string | null;
    id?: string;
  } | null,
): string | null {
  if (!font) {
    return null;
  }
  return font.family ?? font.name ?? font.id ?? null;
}
